import { KnBrDirectiveModule } from 'src/app/shared/directive/kn-br-directive.module';
import { ListNavigationModule, MediaModule, SpinnerModule } from '@spartacus/storefront';
import { I18nModule, ConfigModule, CmsConfig } from '@spartacus/core';
import { KnBrOrderFormSearchResultComponent } from './kn-br-order-form-search-result.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrOrderFormItemComponent } from './kn-br-order-form-item/kn-br-order-form-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { KnBrAddToCartModule } from 'src/app/kn-br-product/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { KnBrAddToQuoteModule } from 'src/app/kn-br-product/kn-br-add-to-quote/kn-br-add-to-quote.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        ListNavigationModule,
        KnBrAddToCartModule,
        KnBrAddToQuoteModule,
        SpinnerModule,
        KnBrDirectiveModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrOrderFormComponent: {
                    component: KnBrOrderFormSearchResultComponent,
                },
            },
        } as CmsConfig),
        KnBrOrderFormSearchResultComponent, KnBrOrderFormItemComponent,
    ],
})
export class KnBrOrderFormSearchResultModule {}
